import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  code: Yup.string().required("Promo code is required."),
  discountType: Yup.string().required("Discount type."),
  expiryDate: Yup.date().typeError("Must be a date.").nullable(true),
});

export default validationSchema;
